import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
// eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input[type=text], textarea'
})
export class TrimDirective {
  constructor(private readonly ngControl: NgControl) {
  }

  @HostListener('blur')
  onBlur(): void {
    if (typeof (this.ngControl.control.value) === 'string') {
      const value = this.ngControl.control.value.trim();
      if (value === '') {
        this.ngControl.control.setValue(null);
      } else {
        this.ngControl.control.setValue(value);
      }
    }
  }
}
